import React from "react";

export default function ProductDisplaySettingsSection({
  isActive,
  handleChange,
}) {
  return (
    <>
      <div className="md:col-span-2">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-500">
          Display Settings
        </h4>
      </div>

      <div className="md:col-span-2">
        <label className="inline-flex items-center gap-3">
          <input
            type="checkbox"
            name="is_active"
            checked={isActive}
            onChange={handleChange}
            className="h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-900"
          />
          <span className="text-sm text-slate-700">Active</span>
        </label>
      </div>
    </>
  );
}